import { Component, OnDestroy, OnInit } from '@angular/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { OrganizationsService } from './../../services/organizations.service'
import { Subscription } from 'rxjs'
import {
	organizationFilter,
	organizationsList,
} from './../../models/organizations.model'
import { OrganizationStatus } from '../../models/organizations.enum'
import { ActivatedRoute, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-organization-list',
	templateUrl: './organization-list.component.html',
	styleUrls: ['./organization-list.component.scss'],
})
export class OrganizationListComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	activeCountries!: any
	noDataFoundMessage =
		'ORGANIZATION.ORGANIZATION_LIST.NO_SERVICEPROVIDERS_FOUND'
	noDataFoundImg!: string
	organizationFilter: organizationFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		SearchText: '',
		status: 1,
		startDate: '',
		endDate: '',
		countryId: null,
		includeActive: null,
		includeInActive: null,
		includeSalon: null,
		includeStore: null,
	}
	filterCount = 0
	organizations: organizationsList[] = []
	organizationStatus = OrganizationStatus
	totalCount = 0
	attachementUrl = environment.attachmentPath
	constructor(
		private SharedService: SharedService,
		private organizationServ: OrganizationsService,
		private ActivatedRoute: ActivatedRoute,
		public translate: TranslateService,
		private router: Router
	) {
		this.SharedService.headerTitle.next(
			`ORGANIZATION.ORGANIZATION_LIST.PAGE_TITLE`
		)
	}

	ngOnInit(): void {
		this.getActiveCountries()
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.organizationFilter.countryId = res['country'] || 224
				this.organizationFilter.status = res['status'] || 1
				this.organizationFilter.paging.pageNumber = res['page'] || 1
				this.organizationFilter.paging.pageSize = res['count'] || 10
				this.SharedService.handleBreadCrumb('service-providers', true, {
					name: '',
					id: '',
					url: '/layout/service-providers',
					queryParams: { ...res },
				})
				this.getOrganizations()
				this.getPendingCount()
			})
		)
	}

	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}

	getOrganizations(search = false, filter: any = null) {
		search ? (this.organizationFilter.paging.pageNumber = 1) : null
		filter
			? (this.organizationFilter = { ...this.organizationFilter, ...filter })
			: null
		this.subscription.add(
			this.organizationServ
				.getOrganizationsList(this.organizationFilter)
				.subscribe((res: any) => {
					this.organizations = res.result?.items

					this.totalCount = res?.result?.totalCount
					!this.organizationFilter.SearchText
						? (this.noDataFoundMessage = `ORGANIZATION.ORGANIZATION_LIST.NO_SERVICEPROVIDERS_${this.organizationStatus
								.find((data) => +data.value == this.organizationFilter.status)
								?.name?.toUpperCase()}`)
						: (this.noDataFoundMessage =
								'ORGANIZATION.ORGANIZATION_LIST.NO_SERVICEPROVIDERS_FOUND')

					!this.organizationFilter.SearchText
						? (this.noDataFoundImg = `sp-empty-${this.organizationFilter.status}.svg`)
						: (this.noDataFoundImg = 'search-no-data-found.svg')
				})
		)
	}

	getPendingCount() {
		const body = {
			SearchText: this.organizationFilter.SearchText,
			status: 1,
			CountryId: this.organizationFilter.countryId,
		}
		this.subscription.add(
			this.organizationServ
				.getServiceProvidersCount(body)
				.subscribe((res: any) => {
					let pending = this.organizationStatus.find((val) => val.value == '1')

					pending
						? ((pending.count = res), (pending.showCount = res ? true : false))
						: null
				})
		)
	}

	tapChanged(event: any) {
		this.router.navigate(['/layout/service-providers'], {
			queryParams: {
				country: this.organizationFilter.countryId,
				status: event,
			},
		})
	}

	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/service-providers'], {
			queryParams: {
				country: this.organizationFilter.countryId,
				status: this.organizationFilter.status,
				page: pageNumber,
				count: pagecount,
			},
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
